import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    FETCH_LOCATIONS: 'FETCH_LOCATIONS',
    FETCH_SMART_LOCATIONS: 'FETCH_SMART_LOCATIONS',
    FETCH_COUNTRY_SUGGESTION: 'FETCH_COUNTRY_SUGGESTION',
    FETCH_CITY_SUGGESTION: 'FETCH_CITY_SUGGESTION',
    FETCH_STATE_SUGGESTION: 'FETCH_STATE_SUGGESTION'
  })
};

export const fetchLocations = createAsyncAction(types.FETCH_LOCATIONS, (search) =>
  api.get(`v1/locations?keyword=${search}`).then((res) => res)
);

export const fetchSmartLocations = createAsyncAction(types.FETCH_SMART_LOCATIONS, (search) =>
  api.get(`v1/search-locations?keyword=${search}`).then((res) => res?.data)
);

export const getCountrySuggestions = createAsyncAction(types.FETCH_COUNTRY_SUGGESTION, (search) =>
  api.get(`v1/get-countries?keyword=${search}`).then((res) => res?.data)
);

export const getStateSuggestions = createAsyncAction(types.FETCH_STATE_SUGGESTION, (search) =>
  api.get(`v1/get-states-by-country?countryName=${search.country}&keyword=${search.state}`).then((res) => res?.data)
);

export const getCitySuggestions = createAsyncAction(types.FETCH_CITY_SUGGESTION, (search) =>
  api
    .get(`v1/get-cities-by-state?countryName=${search.country}&stataName=${search.state}&keyword=${search.city}`)
    .then((res) => res?.data)
);
